(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["input-phone"] && !Shopify.designMode) return;
  try {
    const ALL_PHONE_COUNTRIES = [
    { code: 'FR', name: 'France', dial: '+33', format: '# ## ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'BE', name: 'Belgique', dial: '+32', format: '### ## ## ##', regex: /^[0-9]{8,9}$/ },
    { code: 'CH', name: 'Suisse', dial: '+41', format: '## ### ## ##', regex: /^[0-9]{9}$/ },
    { code: 'LU', name: 'Luxembourg', dial: '+352', format: '### ### ###', regex: /^[0-9]{8,11}$/ },
    { code: 'ES', name: 'Espagne', dial: '+34', format: '### ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'IT', name: 'Italie', dial: '+39', format: '### ### ####', regex: /^[0-9]{9,10}$/ },
    { code: 'DE', name: 'Allemagne', dial: '+49', format: '### ########', regex: /^[0-9]{10,11}$/ },
    { code: 'GB', name: 'Royaume-Uni', dial: '+44', format: '#### ######', regex: /^[0-9]{10}$/ },
    { code: 'US', name: 'États-Unis', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'CA', name: 'Canada', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'PT', name: 'Portugal', dial: '+351', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'NL', name: 'Pays-Bas', dial: '+31', format: '## ########', regex: /^[0-9]{9}$/ },
    { code: 'AT', name: 'Autriche', dial: '+43', format: '### ########', regex: /^[0-9]{10,11}$/ },
    { code: 'IE', name: 'Irlande', dial: '+353', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'PL', name: 'Pologne', dial: '+48', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'RO', name: 'Roumanie', dial: '+40', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'GR', name: 'Grèce', dial: '+30', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'SE', name: 'Suède', dial: '+46', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'NO', name: 'Norvège', dial: '+47', format: '### ## ###', regex: /^[0-9]{8}$/ },
    { code: 'DK', name: 'Danemark', dial: '+45', format: '## ## ## ##', regex: /^[0-9]{8}$/ },
    { code: 'FI', name: 'Finlande', dial: '+358', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'CZ', name: 'République tchèque', dial: '+420', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'HU', name: 'Hongrie', dial: '+36', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'SK', name: 'Slovaquie', dial: '+421', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'HR', name: 'Croatie', dial: '+385', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'SI', name: 'Slovénie', dial: '+386', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'BG', name: 'Bulgarie', dial: '+359', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'EE', name: 'Estonie', dial: '+372', format: '### ####', regex: /^[0-9]{7,8}$/ },
    { code: 'LV', name: 'Lettonie', dial: '+371', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'LT', name: 'Lituanie', dial: '+370', format: '### #####', regex: /^[0-9]{8}$/ },
    { code: 'MT', name: 'Malte', dial: '+356', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'CY', name: 'Chypre', dial: '+357', format: '## ######', regex: /^[0-9]{8}$/ },
    { code: 'IS', name: 'Islande', dial: '+354', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'AL', name: 'Albanie', dial: '+355', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'BA', name: 'Bosnie-Herzégovine', dial: '+387', format: '## ######', regex: /^[0-9]{8}$/ },
    { code: 'ME', name: 'Monténégro', dial: '+382', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'MK', name: 'Macédoine du Nord', dial: '+389', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'RS', name: 'Serbie', dial: '+381', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'MD', name: 'Moldavie', dial: '+373', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'UA', name: 'Ukraine', dial: '+380', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'BY', name: 'Biélorussie', dial: '+375', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'JP', name: 'Japon', dial: '+81', format: '## #### ####', regex: /^[0-9]{10}$/ },
    { code: 'CN', name: 'Chine', dial: '+86', format: '### #### ####', regex: /^[0-9]{11}$/ },
    { code: 'KR', name: 'Corée du Sud', dial: '+82', format: '## #### ####', regex: /^[0-9]{10}$/ },
    { code: 'KP', name: 'Corée du Nord', dial: '+850', format: '### ########', regex: /^[0-9]{10}$/ },
    { code: 'TW', name: 'Taïwan', dial: '+886', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'MN', name: 'Mongolie', dial: '+976', format: '## ## ####', regex: /^[0-9]{8}$/ },
    { code: 'VN', name: 'Vietnam', dial: '+84', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'TH', name: 'Thaïlande', dial: '+66', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'MY', name: 'Malaisie', dial: '+60', format: '## ### ####', regex: /^[0-9]{9,10}$/ },
    { code: 'SG', name: 'Singapour', dial: '+65', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'ID', name: 'Indonésie', dial: '+62', format: '### ### ####', regex: /^[0-9]{10,11}$/ },
    { code: 'PH', name: 'Philippines', dial: '+63', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'LA', name: 'Laos', dial: '+856', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'KH', name: 'Cambodge', dial: '+855', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'MM', name: 'Myanmar', dial: '+95', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'BN', name: 'Brunei', dial: '+673', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'TL', name: 'Timor-Leste', dial: '+670', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'IN', name: 'Inde', dial: '+91', format: '##### #####', regex: /^[0-9]{10}$/ },
    { code: 'PK', name: 'Pakistan', dial: '+92', format: '### #######', regex: /^[0-9]{10}$/ },
    { code: 'BD', name: 'Bangladesh', dial: '+880', format: '#### ######', regex: /^[0-9]{10}$/ },
    { code: 'LK', name: 'Sri Lanka', dial: '+94', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'NP', name: 'Népal', dial: '+977', format: '## ### ####', regex: /^[0-9]{10}$/ },
    { code: 'BT', name: 'Bhoutan', dial: '+975', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'MV', name: 'Maldives', dial: '+960', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'AF', name: 'Afghanistan', dial: '+93', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'KZ', name: 'Kazakhstan', dial: '+7', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'UZ', name: 'Ouzbékistan', dial: '+998', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'TM', name: 'Turkménistan', dial: '+993', format: '## ######', regex: /^[0-9]{8}$/ },
    { code: 'TJ', name: 'Tadjikistan', dial: '+992', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'KG', name: 'Kirghizistan', dial: '+996', format: '### ######', regex: /^[0-9]{9}$/ },
    { code: 'AU', name: 'Australie', dial: '+61', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'NZ', name: 'Nouvelle-Zélande', dial: '+64', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'PG', name: 'Papouasie-Nouvelle-Guinée', dial: '+675', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'FJ', name: 'Fidji', dial: '+679', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'NC', name: 'Nouvelle-Calédonie', dial: '+687', format: '## ####', regex: /^[0-9]{6}$/ },
    { code: 'PF', name: 'Polynésie française', dial: '+689', format: '## ## ##', regex: /^[0-9]{6}$/ },
    { code: 'HK', name: 'Hong Kong', dial: '+852', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'MO', name: 'Macao', dial: '+853', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'AE', name: 'Émirats arabes unis', dial: '+971', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'SA', name: 'Arabie saoudite', dial: '+966', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'IL', name: 'Israël', dial: '+972', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'JO', name: 'Jordanie', dial: '+962', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'LB', name: 'Liban', dial: '+961', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'SY', name: 'Syrie', dial: '+963', format: '## #### ###', regex: /^[0-9]{9}$/ },
    { code: 'IQ', name: 'Irak', dial: '+964', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'KW', name: 'Koweït', dial: '+965', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'OM', name: 'Oman', dial: '+968', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'QA', name: 'Qatar', dial: '+974', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'BH', name: 'Bahreïn', dial: '+973', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'YE', name: 'Yémen', dial: '+967', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'PS', name: 'Palestine', dial: '+970', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'IR', name: 'Iran', dial: '+98', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'TR', name: 'Turquie', dial: '+90', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'AM', name: 'Arménie', dial: '+374', format: '## ######', regex: /^[0-9]{8}$/ },
    { code: 'AZ', name: 'Azerbaïdjan', dial: '+994', format: '## ### ## ##', regex: /^[0-9]{9}$/ },
    { code: 'GE', name: 'Géorgie', dial: '+995', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'ZA', name: 'Afrique du Sud', dial: '+27', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'EG', name: 'Égypte', dial: '+20', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'MA', name: 'Maroc', dial: '+212', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'DZ', name: 'Algérie', dial: '+213', format: '### ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'TN', name: 'Tunisie', dial: '+216', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'LY', name: 'Libye', dial: '+218', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'NG', name: 'Nigeria', dial: '+234', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'KE', name: 'Kenya', dial: '+254', format: '### ######', regex: /^[0-9]{9}$/ },
    { code: 'GH', name: 'Ghana', dial: '+233', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'ET', name: 'Éthiopie', dial: '+251', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'TZ', name: 'Tanzanie', dial: '+255', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'UG', name: 'Ouganda', dial: '+256', format: '### ######', regex: /^[0-9]{9}$/ },
    { code: 'SN', name: 'Sénégal', dial: '+221', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'CI', name: "Côte d'Ivoire", dial: '+225', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'CM', name: 'Cameroun', dial: '+237', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'AO', name: 'Angola', dial: '+244', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'MZ', name: 'Mozambique', dial: '+258', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'ZW', name: 'Zimbabwe', dial: '+263', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'BW', name: 'Botswana', dial: '+267', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'NA', name: 'Namibie', dial: '+264', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'MU', name: 'Maurice', dial: '+230', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'RE', name: 'La Réunion', dial: '+262', format: '#### ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'MG', name: 'Madagascar', dial: '+261', format: '## ## ### ##', regex: /^[0-9]{9}$/ },
    { code: 'RW', name: 'Rwanda', dial: '+250', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'ZM', name: 'Zambie', dial: '+260', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'MW', name: 'Malawi', dial: '+265', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'BR', name: 'Brésil', dial: '+55', format: '## ##### ####', regex: /^[0-9]{10,11}$/ },
    { code: 'AR', name: 'Argentine', dial: '+54', format: '## #### ####', regex: /^[0-9]{10}$/ },
    { code: 'MX', name: 'Mexique', dial: '+52', format: '## #### ####', regex: /^[0-9]{10}$/ },
    { code: 'CL', name: 'Chili', dial: '+56', format: '# #### ####', regex: /^[0-9]{9}$/ },
    { code: 'CO', name: 'Colombie', dial: '+57', format: '### #######', regex: /^[0-9]{10}$/ },
    { code: 'PE', name: 'Pérou', dial: '+51', format: '### ### ###', regex: /^[0-9]{9}$/ },
    { code: 'VE', name: 'Venezuela', dial: '+58', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'EC', name: 'Équateur', dial: '+593', format: '## ### ####', regex: /^[0-9]{9}$/ },
    { code: 'BO', name: 'Bolivie', dial: '+591', format: '# ### ####', regex: /^[0-9]{8}$/ },
    { code: 'PY', name: 'Paraguay', dial: '+595', format: '### ######', regex: /^[0-9]{9}$/ },
    { code: 'UY', name: 'Uruguay', dial: '+598', format: '## ### ###', regex: /^[0-9]{8}$/ },
    { code: 'GY', name: 'Guyana', dial: '+592', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'SR', name: 'Suriname', dial: '+597', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'GF', name: 'Guyane française', dial: '+594', format: '#### ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'CR', name: 'Costa Rica', dial: '+506', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'PA', name: 'Panama', dial: '+507', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'GT', name: 'Guatemala', dial: '+502', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'HN', name: 'Honduras', dial: '+504', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'NI', name: 'Nicaragua', dial: '+505', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'SV', name: 'Salvador', dial: '+503', format: '#### ####', regex: /^[0-9]{8}$/ },
    { code: 'BZ', name: 'Belize', dial: '+501', format: '### ####', regex: /^[0-9]{7}$/ },
    { code: 'CU', name: 'Cuba', dial: '+53', format: '## ######', regex: /^[0-9]{8}$/ },
    { code: 'DO', name: 'République dominicaine', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'HT', name: 'Haïti', dial: '+509', format: '## ## ####', regex: /^[0-9]{8}$/ },
    { code: 'JM', name: 'Jamaïque', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'TT', name: 'Trinité-et-Tobago', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'BS', name: 'Bahamas', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'BB', name: 'Barbade', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'PR', name: 'Porto Rico', dial: '+1', format: '### ### ####', regex: /^[0-9]{10}$/ },
    { code: 'GP', name: 'Guadeloupe', dial: '+590', format: '#### ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'MQ', name: 'Martinique', dial: '+596', format: '#### ## ## ##', regex: /^[0-9]{9}$/ },
    { code: 'RU', name: 'Russie', dial: '+7', format: '### ### ## ##', regex: /^[0-9]{10}$/ },
  ]

  document.addEventListener('DOMContentLoaded', () => {
    const phoneFields = document.querySelectorAll('.contact-form__field--phone')

    phoneFields.forEach((field) => {
      // Filter countries based on data attribute
      const filterString = field.getAttribute('data-countries-filter') || ''
      const allowedCodes = filterString ? filterString.split(',').map((c) => c.trim().toUpperCase()) : null
      const PHONE_COUNTRIES = allowedCodes
        ? ALL_PHONE_COUNTRIES.filter((c) => allowedCodes.includes(c.code))
        : ALL_PHONE_COUNTRIES

      const trigger = field.querySelector('.input-phone__country-trigger')
      const dropdown = field.querySelector('.input-phone__dropdown')
      const countriesList = field.querySelector('.input-phone__countries')
      const searchInput = field.querySelector('.input-phone__search')
      const flagDisplay = field.querySelector('.input-phone__flag-display')
      const arrowIcon = field.querySelector('.input-phone__arrow')
      const hiddenInput = field.querySelector('.input-phone__country-code')
      const phoneInput = field.querySelector('[data-phone-input]')

      let currentCountry = PHONE_COUNTRIES[0]

      // Populate countries list
      const renderCountries = (filter = '') => {
        const filtered = PHONE_COUNTRIES.filter(
          (c) => c.name.toLowerCase().includes(filter.toLowerCase()) || c.dial.includes(filter)
        )

        countriesList.innerHTML = filtered
          .map(
            (country) => `
        <li class='input-phone__country-item' data-code='${country.code}'>
          <img src='https://cdn.shopify.com/static/images/flags/${country.code.toLowerCase()}.svg'
               alt='${country.code}' width='24' height='18'>
          <span>${country.name}</span>
          <span class='input-phone__dial'>${country.dial}</span>
        </li>
      `
          )
          .join('')

        // Add click handlers
        countriesList.querySelectorAll('.input-phone__country-item').forEach((item) => {
          item.addEventListener('click', () => selectCountry(item.dataset.code))
        })
      }

      // Select country
      const selectCountry = (code) => {
        currentCountry = PHONE_COUNTRIES.find((c) => c.code === code) || PHONE_COUNTRIES[0]

        flagDisplay.src = `https://cdn.shopify.com/static/images/flags/${code.toLowerCase()}.svg`
        flagDisplay.alt = code
        hiddenInput.value = currentCountry.dial
        hiddenInput.setAttribute('data-country', code)

        // Only show placeholder for France
        phoneInput.placeholder = code === 'FR' ? '6 12 34 56 78' : ''

        closeDropdown()
        phoneInput.value = ''
        phoneInput.focus()
      }

      // Toggle dropdown
      const toggleDropdown = () => {
        const isOpen = dropdown.classList.contains('is-open')
        if (isOpen) {
          closeDropdown()
        } else {
          dropdown.classList.add('is-open')
          arrowIcon.classList.add('is-open')
          searchInput.value = ''
          renderCountries()
          searchInput.focus()
        }
      }

      const closeDropdown = () => {
        dropdown.classList.remove('is-open')
        arrowIcon.classList.remove('is-open')
      }

      // Format phone number
      const formatPhone = (value) => {
        const digits = value.replace(/\D/g, '')
        const format = currentCountry.format
        let formatted = ''
        let digitIndex = 0

        for (let char of format) {
          if (char === '#') {
            if (digitIndex < digits.length) {
              formatted += digits[digitIndex]
              digitIndex++
            } else {
              break
            }
          } else {
            if (digitIndex < digits.length) {
              formatted += char
            }
          }
        }

        return formatted
      }

      // Event listeners
      trigger.addEventListener('click', toggleDropdown)

      searchInput.addEventListener('input', (e) => {
        renderCountries(e.target.value)
      })

      phoneInput.addEventListener('input', (e) => {
        const cursorPos = e.target.selectionStart
        const oldLength = e.target.value.length
        const formatted = formatPhone(e.target.value)
        e.target.value = formatted

        // Adjust cursor position
        const newLength = formatted.length
        const diff = newLength - oldLength
        e.target.setSelectionRange(cursorPos + diff, cursorPos + diff)
      })

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!field.contains(e.target)) {
          closeDropdown()
        }
      })

      // Initialize
      renderCountries()
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["select-field"] && !Shopify.designMode) return;
  try {
    const ALL_COUNTRIES = [
    'France',
    'Belgique',
    'Suisse',
    'Luxembourg',
    'Allemagne',
    'Autriche',
    'Pays-Bas',
    'Italie',
    'Espagne',
    'Portugal',
    'Royaume-Uni',
    'Irlande',
    'Pologne',
    'République tchèque',
    'Hongrie',
    'Roumanie',
    'Bulgarie',
    'Grèce',
    'Croatie',
    'Slovénie',
    'Slovaquie',
    'Estonie',
    'Lettonie',
    'Lituanie',
    'Malte',
    'Chypre',
    'Suède',
    'Norvège',
    'Danemark',
    'Finlande',
    'Islande',
    'Serbie',
    'Bosnie-Herzégovine',
    'Monténégro',
    'Macédoine du Nord',
    'Albanie',
    'Moldavie',
    'Ukraine',
    'Biélorussie',
    'Russie',
    'Turquie',
    'Arménie',
    'Azerbaïdjan',
    'Géorgie',
    'États-Unis',
    'Canada',
    'Mexique',
    'Brésil',
    'Argentine',
    'Chili',
    'Colombie',
    'Pérou',
    'Venezuela',
    'Équateur',
    'Bolivie',
    'Paraguay',
    'Uruguay',
    'Costa Rica',
    'Panama',
    'Guatemala',
    'Honduras',
    'Nicaragua',
    'Salvador',
    'Belize',
    'Cuba',
    'République dominicaine',
    'Haïti',
    'Jamaïque',
    'Trinité-et-Tobago',
    'Bahamas',
    'Barbade',
    'Porto Rico',
    'Guadeloupe',
    'Martinique',
    'Guyane française',
    'Guyana',
    'Suriname',
    'Chine',
    'Japon',
    'Corée du Sud',
    'Corée du Nord',
    'Taïwan',
    'Mongolie',
    'Vietnam',
    'Thaïlande',
    'Malaisie',
    'Singapour',
    'Indonésie',
    'Philippines',
    'Laos',
    'Cambodge',
    'Myanmar',
    'Brunei',
    'Timor-Leste',
    'Inde',
    'Pakistan',
    'Bangladesh',
    'Sri Lanka',
    'Népal',
    'Bhoutan',
    'Maldives',
    'Afghanistan',
    'Kazakhstan',
    'Ouzbékistan',
    'Turkménistan',
    'Tadjikistan',
    'Kirghizistan',
    'Hong Kong',
    'Macao',
    'Émirats arabes unis',
    'Arabie saoudite',
    'Israël',
    'Jordanie',
    'Liban',
    'Syrie',
    'Irak',
    'Koweït',
    'Oman',
    'Qatar',
    'Bahreïn',
    'Yémen',
    'Palestine',
    'Iran',
    'Australie',
    'Nouvelle-Zélande',
    'Papouasie-Nouvelle-Guinée',
    'Fidji',
    'Nouvelle-Calédonie',
    'Polynésie française',
    'Afrique du Sud',
    'Égypte',
    'Maroc',
    'Algérie',
    'Tunisie',
    'Libye',
    'Nigeria',
    'Kenya',
    'Ghana',
    'Éthiopie',
    'Tanzanie',
    'Ouganda',
    'Sénégal',
    "Côte d'Ivoire",
    'Cameroun',
    'Angola',
    'Mozambique',
    'Zimbabwe',
    'Botswana',
    'Namibie',
    'Maurice',
    'La Réunion',
    'Madagascar',
    'Rwanda',
    'Zambie',
    'Malawi',
  ]

  document.addEventListener('DOMContentLoaded', () => {
    const countrySelects = document.querySelectorAll('.contact-form__field--country-select')

    countrySelects.forEach((field) => {
      const trigger = field.querySelector('.country-select__trigger')
      const triggerText = field.querySelector('.country-select__trigger-text')
      const dropdown = field.querySelector('.country-select__dropdown')
      const searchInput = field.querySelector('.country-select__search')
      const countriesList = field.querySelector('.country-select__list')
      const arrowIcon = field.querySelector('.country-select__arrow')
      const hiddenInput = field.querySelector('input[type="hidden"]')

      // Filter countries based on data attribute
      const filterString = field.getAttribute('data-country-filter') || ''
      const allowedCountries = filterString ? filterString.split(',').map((c) => c.trim()) : null
      const COUNTRIES = allowedCountries
        ? ALL_COUNTRIES.filter((country) =>
            allowedCountries.some((allowed) => country.toLowerCase() === allowed.toLowerCase())
          )
        : ALL_COUNTRIES

      let currentCountry = COUNTRIES[0] || 'France'

      // Render countries list
      const renderCountries = (filter = '') => {
        const filtered = COUNTRIES.filter((country) => country.toLowerCase().includes(filter.toLowerCase()))

        countriesList.innerHTML = filtered
          .map(
            (country) => `
          <li class='country-select__item body-m-base ${country === currentCountry ? 'is-selected' : ''}' data-country='${country}'>
            <span>${country}</span>
          </li>
        `
          )
          .join('')

        // Add click handlers
        countriesList.querySelectorAll('.country-select__item').forEach((item) => {
          item.addEventListener('click', () => selectCountry(item.dataset.country))
        })
      }

      // Select country
      const selectCountry = (country) => {
        currentCountry = country
        triggerText.textContent = country
        hiddenInput.value = country
        closeDropdown()
        searchInput.value = ''
        renderCountries()
      }

      // Toggle dropdown
      const toggleDropdown = () => {
        const isOpen = dropdown.classList.contains('is-open')
        if (isOpen) {
          closeDropdown()
        } else {
          dropdown.classList.add('is-open')
          arrowIcon.classList.add('is-open')
          searchInput.value = ''
          renderCountries()
          searchInput.focus()
        }
      }

      const closeDropdown = () => {
        dropdown.classList.remove('is-open')
        arrowIcon.classList.remove('is-open')
      }

      // Event listeners
      trigger.addEventListener('click', toggleDropdown)

      searchInput.addEventListener('input', (e) => {
        renderCountries(e.target.value)
      })

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!field.contains(e.target)) {
          closeDropdown()
        }
      })

      // Initialize
      selectCountry(currentCountry)
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["textarea-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-textarea-field]').forEach((wrapper) => {
      const textarea = wrapper.querySelector('textarea')
      const charCount = wrapper.querySelector('.char-count')

      if (textarea && charCount) {
        const updateCounter = () => {
          const count = textarea.value.length
          charCount.textContent = String(count).padStart(3, '0')

          const maxLength = parseInt(textarea.getAttribute('maxlength'))
          const warningThreshold = maxLength * 0.9
          const criticalThreshold = maxLength * 0.8

          if (count > warningThreshold) {
            charCount.style.color = '#c00'
          } else if (count > criticalThreshold) {
            charCount.style.color = '#ff9800'
          } else {
            charCount.style.color = ''
          }
        }

        textarea.addEventListener('input', updateCounter)
        updateCounter() // Initialize
      }
    })
  })
  } catch(e) { console.error(e); }
})();

})();
